// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2s389","title":"Header_title__eBYGB","side":"Header_side__3UqY8"};